import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { ICourseModule } from "../models/courseModule.model";

@Injectable()
export class CourseModuleService {
    courseModules$!: Observable<ICourseModule[]>;
    newCourseModule$!: Observable<ICourseModule>;
    createdCourseModule!: ICourseModule;

    private http = inject(HttpClient);
    private authService = inject(AuthenticationService);

    getCourseModules(): Observable<ICourseModule[]> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.get<ICourseModule[]>(environment.API_URL + '/api/CourseModule/', options);
        } else {
            return of([]);
        }
    }

    getCourseModulesByCourse(courseId: string): Observable<ICourseModule[]> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.get<ICourseModule[]>(environment.API_URL + `/api/CourseModule/ByCourseId/${courseId}/true`, options);
        } else {
            return of([]);
        }
    }

    getCourseModule(id: string | undefined): Observable<ICourseModule> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.get<ICourseModule>(environment.API_URL + `/api/courseModule/ById/${id}`, options);
        } else {
            return of();
        }
    }

    deleteCourseModule(id: string): Observable<ICourseModule> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        let params = {
            id: id
        };

        if (token) {
            return this.http.post<ICourseModule>(environment.API_URL + `/api/courseModule/delete`, params, options);
        } else {
            return of();
        }
    }

    createCourseModule(courseModule: ICourseModule): Observable<ICourseModule> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };

        if (token) {
            return this.http.post<ICourseModule>(environment.API_URL + '/api/courseModule/create', courseModule, options);
        } else {
            return of();
        }
    }

    editCourseModule(courseModule: ICourseModule): Observable<ICourseModule> {
        const token = this.authService.getUserToken();
        let options = { headers: new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }) };
        if (token) {
            return this.http.post<ICourseModule>(environment.API_URL + '/api/courseModule/update', courseModule, options);
        } else {
            return of();
        }
    }

    getNextOrder(): Observable<number> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<number>( environment.API_URL + `/api/courseModule/getNextOrder`, options);
        } else {
            return of();
        }
    }
}
